const TabsList = [
  {
    id: 1,
    title: 'Buy Forex',
    tagLine: 'Multi-currency card or cash at your convenience​',
    activeTab: 'BUY',
  },
  {
    id: 2,
    title: 'Sell Forex',
    tagLine: 'Competitive exchange rates with minimum efforts​​',
    activeTab: 'SELL',
  },
  {
    id: 3,
    title: 'Send Money Abroad',
    tagLine: 'Hassle-free international money transfers ​​',
    activeTab: 'ABROAD',
  },
  {
    id: 4,
    title: 'Reload Forex Card',
    tagLine: 'Top-up your Forex Card anytime, anywhere​',
    activeTab: 'RELOAD',
  },
  {
    id: 5,
    title: 'Unload Forex Card',
    tagLine: 'Sell unspent currency from your card ​​',
    activeTab: 'UNLOAD',
  },
];

export default TabsList;
